import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCaretDown,
  faDownload,
  faEnvelopeOpenText,
  faFileCode,
  faFilePdf,
} from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

const SOURCE_FILE_OPTIONS = [
  { kind: "pdf", icon: faFilePdf, labelKey: "downloadSourcePdf" },
  { kind: "eml", icon: faEnvelopeOpenText, labelKey: "openSourceEmail" },
  { kind: "json", icon: faFileCode, labelKey: "downloadSourceJson" },
];

const SourceFilesMenu = ({ availability = {}, loadingKind = "", onSelect, buttonClassName = "btn-default" }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const closeOnOutsideClick = (event) => {
      if (!containerRef.current?.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", closeOnOutsideClick);
    return () => document.removeEventListener("mousedown", closeOnOutsideClick);
  }, []);

  const selectFile = (kind) => {
    setOpen(false);
    onSelect(kind);
  };

  return (
    <div className="grid-report-export-menu" ref={containerRef}>
      <button
        type="button"
        className={`btn ${buttonClassName} grid-report-export-button`}
        onClick={() => setOpen((current) => !current)}
        disabled={Boolean(loadingKind)}
        aria-haspopup="menu"
        aria-expanded={open}
      >
        <FontAwesomeIcon icon={faDownload} />
        <span>
          {loadingKind
            ? t("common.loading")
            : t("salesOrderInboundMessages.sourceFiles")}
        </span>
        <FontAwesomeIcon icon={faCaretDown} className="grid-report-export-caret" />
      </button>
      {open && (
        <div className="grid-report-export-dropdown" role="menu">
          {SOURCE_FILE_OPTIONS.map((option) => {
            const label = t(`salesOrderInboundMessages.${option.labelKey}`);
            return (
              <button
                key={option.kind}
                type="button"
                role="menuitem"
                onClick={() => selectFile(option.kind)}
                disabled={!availability[option.kind]}
                title={!availability[option.kind]
                  ? t("salesOrderInboundMessages.sourceFileUnavailable")
                  : label}
              >
                <FontAwesomeIcon icon={option.icon} />
                <span>{label}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default SourceFilesMenu;
